exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SparkGoals-module__wrapper___7eyfb{width:100%;display:grid;gap:.5rem;margin-bottom:.75rem}.SparkGoals-module__wrapper___7eyfb .SparkGoals-module__sparks___3Ym2a{position:relative}.SparkGoals-module__wrapper___7eyfb .SparkGoals-module__spark-skill___1JTJy{display:flex;color:#b4bac3;justify-content:space-between;cursor:pointer}.SparkGoals-module__wrapper___7eyfb .SparkGoals-module__spark-skill___1JTJy .SparkGoals-module__reflection-skill___34zj4{text-transform:uppercase;font-size:14px;font-weight:700}.SparkGoals-module__wrapper___7eyfb .SparkGoals-module__spark-skill___1JTJy .SparkGoals-module__end___2RCv1{display:flex;gap:.75rem}", ""]);

// exports
exports.locals = {
	"wrapper": "SparkGoals-module__wrapper___7eyfb",
	"sparks": "SparkGoals-module__sparks___3Ym2a",
	"spark-skill": "SparkGoals-module__spark-skill___1JTJy",
	"reflection-skill": "SparkGoals-module__reflection-skill___34zj4",
	"end": "SparkGoals-module__end___2RCv1"
};